export { EstatePlanningManagementPageTemplate } from './EstatePlanningManagementPageTemplate';
